import React from 'react'
import completedImg from "../../../../../../assets/images/photographerOnboarding/completed.svg"
import {useDispatch} from "react-redux";
import {openProjectModal} from "../../../../actions/landing_page_actions";

export const Completed = () => {
  const dispatch = useDispatch()

  const onClick = (e) => {
    e.preventDefault()
    dispatch(openProjectModal())
  }

  return <div>
    <div className="schedule-demo-title">
      We'll be in touch shortly!<br/><br/>As a thank you - use code <strong>SAVE20</strong> to save 20% on your first shoot.
    </div>

    <div className="schedule-demo-center-image-wrapper">
      <img src={completedImg}/>
    </div>
    <div className="schedule-demo-divider"/>
    <div className="mar-top-20">
      <button className="projectEditButton projectEditButtonPrimary projectEditButtonLarger w-100" onClick={onClick}>
        Book Shoot / View Pricing
      </button>
    </div>
  </div>
}